import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { toExponentialUppercaseWhitZero } from "@app/utils/functions";
import { Checkbox } from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid";

export function procesarRPTOut(contenido): any {
  if (!contenido) return [];
  const lineas = contenido.split("\n");
  let isInterferenceSection = false;
  let isMDAReportSection = false;
  let initMDAReportSection = false;
  let interferenceData: any = [];
  let mdaData = {};

  lineas.forEach((line) => {
    if (line.includes("Identificaci¢n de radionuclidos por interferencia")) {
      isInterferenceSection = true;
      isMDAReportSection = false;
      return;
    }

    if (line.includes("N U C L I D E")) {
      isInterferenceSection = false;
      isMDAReportSection = true;
      return;
    }

    if (isInterferenceSection) {
      const parts = line.trim().split(/\s+/);

      if (line.includes("? = Solucion indeterminada"))
        isInterferenceSection = false;

      if (parts.length >= 4) {
        const isotopo = parts[0];
        const isotopoID = parts[1];
        const actividad = parts[2];
        const incertidumbre = parts[3];

        if (!isNaN(actividad) && !isNaN(incertidumbre)) {
          interferenceData.push({
            isotopo,
            isotopoID,
            actividad,
            incertidumbre,
          });
        }
      }
    }

    if (isMDAReportSection) {
      const parts = line.trim().split(/\s+/);

      if (parts.includes("^4")) initMDAReportSection = true;
      if (parts.includes("^5")) isMDAReportSection = false;

      if (initMDAReportSection && parts.length >= 6) {
        const isotopo = parts[0] === "+" ? parts[1] : parts[0];
        if (isotopo === "Name" || isotopo === ">") return;

        const lineMDA = parseFloat(parts[0] === "+" ? parts[4] : parts[3]);
        const lid = parts[0] === "+" ? parts[5] : parts[4];
        const actividad = parts[0] === "+" ? parts[6] : parts[5];
        const lc = parts[0] === "+" ? parts[7] : parts[6];
        if (!isNaN(lineMDA) && !isNaN(lid)) {
          if (
            !mdaData[isotopo] ||
            Math.abs(lineMDA - lid) <
              Math.abs(mdaData[isotopo].lineMDA - mdaData[isotopo].lid)
          ) {
            mdaData[isotopo] = { lineMDA, lid, lc, actividad };
          }
        }
      }
    }
  });
  const data = interferenceData.map((item) => ({
    isotopo: item.isotopo,
    isotopoID: item.isotopoID,
    actividad: item.actividad,
    incertidumbre: item.incertidumbre,
    lid: mdaData[item.isotopo]?.lid || null,
    lc: mdaData[item.isotopo]?.lc || null,
  }));

  const missingMDA = Object.keys(mdaData)
    .filter(
      (isotopo) => !interferenceData.some((data) => data.isotopo === isotopo)
    )
    .map((isotopo) => ({
      isotopo,
      incertidumbre: null,
      lid: mdaData[isotopo].lid,
      lc: mdaData[isotopo].lc,
      actividad: mdaData[isotopo].actividad,
    }));
  return [...data, ...missingMDA];
}

export function mapDataToIsotopes(dataList, isotopesList, calculation) {
  if (!dataList) return [];
  return dataList.map((data) => {
    const isotopeKey = data.isotopo.replace("-", "");
    const isotopeMatch = isotopesList.find((iso) => iso.codigo === isotopeKey);

    return {
      isotope: isotopeMatch ? isotopeMatch.id : null,
      activity: data.actividad,
      uncertainty: data.incertidumbre,
      lid: data.lid,
      lc: data.lc,
      requested_by_client: 0,
      calculation: calculation,
    };
  });
}

export const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxHeight: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  px: 4,
  py: 2,
  overflowY: "auto",
};

export const columnsWhitMatch: GridColDef[] = [
  {
    field: "isotope",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
    valueGetter: (params) => params.row.isotope?.codigo || "",
    renderCell: (params) => (
      <strong>{params.row.isotope?.codigo || ""}</strong>
    ),
  },
  {
    field: "activity",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div>{toExponentialUppercaseWhitZero(params.row.activity, 2)}</div>
    ),
  },
  {
    field: "uncertainty",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div>{toExponentialUppercaseWhitZero(params.row.uncertainty, 2)}</div>
    ),
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</div>
    ),
  },
];

export const columnsWhitOutMatch: GridColDef[] = [
  {
    field: "actions",
    headerName: "Solicitado por el cliente",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => {
      const label = {
        inputProps: { "aria-label": "Solicitado por el cliente" },
      };
      return (
        <>
          <Checkbox
            {...label}
            defaultChecked={params.row.requested_by_client}
            onClick={() =>
              useAnalysis
                .getState()
                .updateRequestedByClient(
                  params.row.id,
                  params.row.requested_by_client ? 0 : 1
                )
            }
          />
        </>
      );
    },
  },
  {
    field: "isotope",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
    valueGetter: (params) => params.row.isotope?.codigo || "",
    renderCell: (params) => (
      <strong>{params.row.isotope?.codigo || ""}</strong>
    ),
  },
  {
    field: "activity",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div>{toExponentialUppercaseWhitZero(params.row.activity, 2)}</div>
    ),
  },
  {
    field: "uncertainty",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div>{toExponentialUppercaseWhitZero(params.row.uncertainty, 2)}</div>
    ),
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    flex: 0,
    renderCell: (params) => (
      <div>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</div>
    ),
  },
];

export const columnsOnlyLidORBothTrue: GridColDef[] = [
  {
    field: "isotope",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
    valueGetter: (params) => params.row.isotope?.codigo || "",
    renderCell: (params) => (
      <strong>{params.row.isotope?.codigo || ""}</strong>
    ),
  },
  {
    field: "activity",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <span>
        {parseFloat(params.row.activity) <= parseFloat(params.row.lid) &&
        parseFloat(params.row.activity) <= parseFloat(params.row.uncertainty)
          ? ""
          : toExponentialUppercaseWhitZero(params.row.activity, 2)}
      </span>
    ),
  },
  {
    field: "uncertainty",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <span>
        {!params.row.uncertainty ||
        (parseFloat(params.row.activity) <= parseFloat(params.row.lid) &&
          parseFloat(params.row.activity) <= parseFloat(params.row.uncertainty))
          ? ""
          : toExponentialUppercaseWhitZero(params.row.uncertainty, 2)}
      </span>
    ),
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
  },
  {
    field: "lc",
    headerName: "Limite Critico",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lc, 2)}</span>
    ),
  },
];

export const columnsLidCharterizacionFalse: GridColDef[] = [
  {
    field: "isotope",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
    valueGetter: (params) => params.row.isotope?.codigo || "",
    renderCell: (params) => (
      <strong>{params.row.isotope?.codigo || ""}</strong>
    ),
  },
  {
    field: "activity",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.activity, 2)}</span>
    ),
    flex: 1,
  },
  {
    field: "uncertainty",
    headerName: "Incertidumbre",
    headerAlign: "center",
    renderCell: (params) => (
      <span>
        {!params.row.uncertainty
          ? ""
          : toExponentialUppercaseWhitZero(params.row.uncertainty, 2)}
      </span>
    ),
    align: "center",
    flex: 1,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
    align: "center",
    flex: 1,
  },
  {
    field: "lc",
    headerName: "Limite Critico",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lc, 2)}</span>
    ),
    flex: 1,
  },
];

export const columnsOnlyCharterizacion = (): GridColDef[] => {
  const renderUncertainty = (
    params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  ) => {
    if (!params.row.uncertainty) return "";
    const uncertainty = parseFloat(params.row.uncertainty);
    const activity = parseFloat(params.row.activity);
    const lid = parseFloat(params.row.lid);
    const lc = parseFloat(params.row.lc);

    if (activity > lid)
      return toExponentialUppercaseWhitZero(params.row.uncertainty, 2);
    else if ((activity > 0 && activity < lid) || activity > lc)
      return toExponentialUppercaseWhitZero(params.row.uncertainty, 2);

    return "";
  };

  const renderLc = (
    params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  ) => {
    const activity = parseFloat(params.row.activity);
    const lid = parseFloat(params.row.lid);
    const lc = parseFloat(params.row.lc);

    //if (activity > lid) return lc;

    return toExponentialUppercaseWhitZero(params.row.lc, 2);
  };

  return [
    {
      field: "isotope",
      headerName: "Isótopo",
      headerAlign: "left",
      align: "left",
      flex: 1,
      valueGetter: (params) => params.row.isotope?.codigo || "",
      renderCell: (params) => (
        <strong>{params.row.isotope?.codigo || ""}</strong>
      ),
    },
    {
      field: "activity",
      headerName: "Actividad",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span>{toExponentialUppercaseWhitZero(params.row.activity, 2)}</span>
      ),
      flex: 1,
    },
    {
      field: "uncertainty",
      headerName: "Incertidumbre",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <span>{renderUncertainty(params)}</span>,
      flex: 1,
    },
    {
      field: "lid",
      headerName: "LID",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
      ),
      flex: 1,
    },
    {
      field: "lc",
      headerName: "Limite Critico",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => <span>{renderLc(params)}</span>,
      flex: 1,
    },
  ];
};

export const columnsAxe: GridColDef[] = [
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

export const columnsAxeWithClientRequest: GridColDef[] = [
  {
    field: "requested",
    headerName: "Solicitado",
    headerAlign: "center",
    align: "center",
    flex: 0.5,
    renderCell: (params: any) => {
      const label = {
        inputProps: { "aria-label": "Solicitado por el cliente" },
      };
      return (
        <>
          <Checkbox
            {...label}
            checked={params.row.requested_by_client || false}
            onChange={() => {
              if (params.row.onToggleRequested) {
                params.row.onToggleRequested(params.row);
              }
            }}
          />
        </>
      );
    },
  },
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

// Columnas con checkbox para isótopos solicitados - cuando ambas opciones están marcadas
export const columnsAxeWithClientRequestOnlyLidORBothTrue: GridColDef[] = [
  {
    field: "requested",
    headerName: "Solicitado",
    headerAlign: "center",
    align: "center",
    flex: 0.5,
    renderCell: (params: any) => {
      const label = {
        inputProps: { "aria-label": "Solicitado por el cliente" },
      };
      return (
        <>
          <Checkbox
            {...label}
            checked={params.row.requested_by_client || false}
            onChange={() => {
              if (params.row.onToggleRequested) {
                params.row.onToggleRequested(params.row);
              }
            }}
          />
        </>
      );
    },
  },
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const activity = parseFloat(params.row.actividad);
      const lid = parseFloat(params.row.lid);
      const uncertainty = parseFloat(params.row.incertidumbre);
      
      if (activity <= lid && activity <= uncertainty) {
        return <span></span>;
      }
      return <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>;
    },
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const activity = parseFloat(params.row.actividad);
      const lid = parseFloat(params.row.lid);
      const uncertainty = parseFloat(params.row.incertidumbre);
      
      if (!params.row.incertidumbre || (activity <= lid && activity <= uncertainty)) {
        return <span></span>;
      }
      return <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>;
    },
    flex: 0,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

// Columnas con checkbox para isótopos solicitados - cuando ninguna opción está marcada
export const columnsAxeWithClientRequestLidCharterizacionFalse: GridColDef[] = [
  {
    field: "requested",
    headerName: "Solicitado",
    headerAlign: "center",
    align: "center",
    flex: 0.5,
    renderCell: (params: any) => {
      const label = {
        inputProps: { "aria-label": "Solicitado por el cliente" },
      };
      return (
        <>
          <Checkbox
            {...label}
            checked={params.row.requested_by_client || false}
            onChange={() => {
              if (params.row.onToggleRequested) {
                params.row.onToggleRequested(params.row);
              }
            }}
          />
        </>
      );
    },
  },
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

// Columnas con checkbox para isótopos solicitados - cuando sólo report_characterization está marcado
export const columnsAxeWithClientRequestOnlyCharterizacion = (): GridColDef[] => [
  {
    field: "requested",
    headerName: "Solicitado",
    headerAlign: "center",
    align: "center",
    flex: 0.5,
    renderCell: (params: any) => {
      const label = {
        inputProps: { "aria-label": "Solicitado por el cliente" },
      };
      return (
        <>
          <Checkbox
            {...label}
            checked={params.row.requested_by_client || false}
            onChange={() => {
              if (params.row.onToggleRequested) {
                params.row.onToggleRequested(params.row);
              }
            }}
          />
        </>
      );
    },
  },
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

// Columnas para Axe cuando ambas opciones están marcadas (only_lid y report_characterization)
export const columnsAxeOnlyLidORBothTrue: GridColDef[] = [
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const activity = parseFloat(params.row.actividad);
      const lid = parseFloat(params.row.lid);
      const uncertainty = parseFloat(params.row.incertidumbre);
      
      if (activity <= lid && activity <= uncertainty) {
        return <span></span>;
      }
      return <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>;
    },
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const activity = parseFloat(params.row.actividad);
      const lid = parseFloat(params.row.lid);
      const uncertainty = parseFloat(params.row.incertidumbre);
      
      if (!params.row.incertidumbre || (activity <= lid && activity <= uncertainty)) {
        return <span></span>;
      }
      return <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>;
    },
    flex: 0,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

// Columnas para Axe cuando ninguna opción está marcada
export const columnsAxeLidCharterizacionFalse: GridColDef[] = [
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "lid",
    headerName: "LID",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.lid, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

// Columnas para Axe cuando sólo report_characterization está marcado
export const columnsAxeOnlyCharterizacion = (): GridColDef[] => [
  {
    field: "isotopoFile",
    headerName: "Isótopo",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "energy",
    headerName: "Energia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "cuenta",
    headerName: "Cuentas",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "efficiency",
    headerName: "Eficiencia",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "error",
    headerName: "% Error",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "actividad",
    headerName: "Actividad",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.actividad, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "incertidumbre",
    headerName: "Incertidumbre",
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{toExponentialUppercaseWhitZero(params.row.incertidumbre, 2)}</span>
    ),
    flex: 0,
  },
  {
    field: "fondo_integration_to_apply",
    headerName: "Fondo Integral",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_to_apply",
    headerName: "Fondo Area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
  {
    field: "fondo_area_error_to_apply",
    headerName: "Error fondo area",
    headerAlign: "center",
    align: "center",
    flex: 0,
  },
];

export function lastDetector(countingEquipment, equipmentList) {
  if (!Array.isArray(countingEquipment) || countingEquipment.length === 0)
    return null;

  return (
    [...countingEquipment]
      .reverse()
      .map(({ id }) => equipmentList.find((eq) => eq.id === id))
      .find((equipment) => equipment?.is_geometry) || null
  );
}

export function lastEquipment(countingEquipment, equipmentList) {
  if (!Array.isArray(countingEquipment) || countingEquipment.length === 0)
    return null;

  return (
    [...countingEquipment]
      .reverse()
      .map(({ id }) => equipmentList.find((eq) => eq.id === id))
      .find((equipment) => !equipment?.is_geometry) || null
  );
}
